import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { GetMyNotificationMessageList } from '../../store/NTX/Notifications/notificationSlice';

const useGetMyNotificationMessage = () => {
  const dispatch = useAppDispatch();
  const { MyNotificationMessageList, loading2: loading } = useAppSelector(state => state.Notifications);

  useEffect(() => {
    // if (!MyNotificationMessageList?.length) {
    // }
    // dispatch(GetMyNotificationMessageList());
  }, []);

  useEffect(() => {
    // const intervalId = setInterval(() => {
    //   dispatch(GetMyNotificationMessageList());
    // }, 600000); // Update every twelve seconds

    // return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []); // Re-run effect when notification list changes

  return { MyNotificationMessageList, loading };
};

export default useGetMyNotificationMessage;
